<template>
  <v-card>
      <v-card-title>
        <!-- <v-flex xs6>
          <cal-picker data-vv-scope="filterForm" :label="filtersLabel.effDate" v-model="filters.effDate"></cal-picker>
        </v-flex> -->
        <div class="headline">Product Listing</div>
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-autocomplete :items="productList" v-model="filters.search" :label="filtersLabel.product" item-text="label" item-value="value" clearable></v-autocomplete>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="filters.search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.effDate) }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.endDate) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" remove review @review="doReview" @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Product<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="productDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Permit Product for Business Class</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 class="ma-2" v-if="!newBusClsProduct">
                  <v-subheader class="queryLabel">{{labels.productQuery}}</v-subheader>
                  <div class="title">{{productForm.product}}</div>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-autocomplete :label="labels.product" v-model="productForm.product" :items="productList" item-text="label" item-value="value" :error-messages="errors.first('busCls') ? errors.first('busCls') :errors.collect('product')" data-vv-name="product" :data-vv-as="labels.product" v-validate="'required'" :loading="productLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="!newBusClsProduct">
                  <cal-picker :label="labels.effDate" v-model="productForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" ref="afterDate"></cal-picker>
                </v-flex>
                <v-flex xs4 v-else>
                  <cal-picker :label="labels.effDate" v-model="productForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" ref="afterDate"></cal-picker>
                </v-flex>
                <v-flex xs4>
                  <cal-picker :label="labels.endDate" v-model="productForm.endDate" :error-messages="errors.collect('endDate')" data-vv-name="endDate" :data-vv-as="labels.endDate" :min="productForm.effDate" v-validate="'after:afterDate, afterDate'"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Product?
      <div class="title">{{deleteProductBusCls}}</div>
      </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import toDate from 'date-fns/toDate'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      headers: [
        { text: 'Product', value: 'description' },
        { text: 'Effect Date', value: 'effDate' },
        { text: 'End Date', value: 'endDate' },
        TableConst.tableActionHeader
      ],
      filtersLabel: {
        product: 'Product',
        effDate: 'Effective Date'
      },
      filters: {
        effDate: null
      },
      labels: {
        productQuery: 'Product',
        product: 'Product*',
        effDate: 'Effective Date*',
        endDate: 'End Date'
      },
      productForm: {
        product: null,
        busCls: null,
        effDate: null,
        endDate: null
      },
      pagination: {
        sortBy: 'effDate'
      },
      loading: null,
      newBusCls: false,
      productList: [],
      productDialog: false,
      productLoading: false,
      newBusClsProduct: false,
      menu: [],
      deleteProductBusCls: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    appID() {
      return this.$store.state.parameters.appID
    },
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu.menu
    }
  },
  methods: {
    async doInit() {
      if (!this.newBusCls) {
        // Review
        await this.fetchData(this.id)
      }
      await this.productListInit()
    },
    async fetchData(xbuscls) {
      this.loading = true
      const apiURI = this.busClsMenu.busClsProducts
      let expand = {
        busCls: xbuscls
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((productBusCls) => {
              const convertProductBusCls = {
                product: productBusCls.product,
                busCls: productBusCls.busCls,
                description: productBusCls.product + ' - ' + productBusCls.description,
                effDate: productBusCls.effDate,
                endDate: productBusCls.endDate
              }
              this.items.push(convertProductBusCls)
            })
          } else {
            this.items = []
          }
        }
        this.loading = false
      }
    },
    doClearFilters() {
      this.filters.product = null
      this.filters.busCls = null
      this.filters.effDate = null
      this.fetchData(this.id)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(this.id)
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.productForm.product = null
      this.productForm.busCls = this.id
      this.productForm.effDate = null
      this.productForm.endDate = null
      this.productDialog = true
      this.newBusClsProduct = true
    },
    async doReview(item) {
      this.newBusClsProduct = false
      const apiURI = this.busClsMenu.busClsProduct
      if (apiURI) {
        try {
          const expand = {
            appID: this.appID,
            product: item.item.product,
            busCls: item.item.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.productForm.product = data.productBusCls.product
            this.productForm.busCls = data.productBusCls.busCls
            this.productForm.effDate = toDate(data.productBusCls.effDate)
            if (data.productBusCls.endDate !== undefined) {
              this.productForm.endDate = toDate(data.productBusCls.endDate)
            }
            this.productDialog = true
            this.menu = extractMenu(result.data._links)
          } else {
            this.$snotify.error('Invalid API URL - Product Business Class Review')
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL -Product Business Class Review')
      }
    },
    async productListInit() {
      const apiURI = this.busClsMenu.productList
      if (apiURI) {
        try {
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.productList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Business Class List')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newBusClsProduct) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.busClsMenu.busClsProductUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.productForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.productForm.busCls)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Business Class Update')
      }
    },
    async doCreate() {
      const apiURI = this.busClsMenu.busClsProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.productForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.productForm.busCls)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Business Class Create')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProductBusCls = data
        this.deleteProductBusCls = data.description
      }
    },
    async doRemove() {
      const apiURI = this.busClsMenu.busClsProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          product: this.selectedProductBusCls.product,
          busCls: this.id
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Product Business Class')
      }
    },
    doClose() {
      this.resetMessages()
      this.productForm.product = undefined
      this.productForm.effDate = undefined
      this.productForm.endDate = undefined
      this.productDialog = false
    }
  },
  mounted() {
    if (this.busCls === 'new') {
      this.newBusCls = true
    } else {
      this.doInit()
    }
  },
  created() {

  },
  props: ['id'],
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
